<template>
    <TopNav></TopNav>
        <h1>Debt Repayment Calculator</h1>
        <fieldset>
        <legend>Debt Repayment Calculator</legend>
            <label for="balancedOwedId">Balanced owed:</label> <input type="number" v-model.number="balancedOwed" id="balancedOwedId" step="any" min="0"> $
            <br>
            <label for="interestRateId">Annual interest rate:</label> <input type="number" v-model.number="interestRate" id="interestRateId" step="any" min="0"> %
            <br>
            <label for="monthlyPaymentId">Monthly payment:</label> <input type="number" v-model.number="monthlyPayment" id="monthlyPaymentId" step="any" min="0"> $
            <br><br>
            Months to pay off: around <output class="blue">{{ outputMonthsToPayOff() }} months</output>
        </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
    name: 'DebtRepayment',
    data() {
        return {
            balancedOwed: 0,
            interestRate: 0,
            monthlyPayment: 0
        }
        },
        components: {
            TopNav
        },
        methods: {
            outputMonthsToPayOff: function () {
                const monthlyInterestRate = this.interestRate / (100 * 12);
                const dividend = Math.log(this.monthlyPayment / (this.monthlyPayment - monthlyInterestRate * this.balancedOwed));
                const divisor = Math.log(1 + monthlyInterestRate);
                const months = dividend / divisor;
                return Math.ceil(months);
            },
        },
    };
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

body {
    margin: 1em auto;
    margin-top: 0;
    max-width: 40em;
    font-family: Arial, Helvetica, sans-serif;
}

label {
    display: inline-block;
    width: 175px;
}

footer section a {
    margin: 20px;
}

.blue {
    color: blue;
}
</style>
